import { useEffect } from "react";
import { create } from "zustand";
import api from "~/services/api";

export const useTicketUnread = create((set) => ({
  count: 0,
  ids: [],
  refresh: async () => {
    try {
      const { data } = await api.get("/tickets/unread");
      set({ count: data.count, ids: data.ids });
    } catch {
    }
  },
}));

export function useTicketUnreadPolling(enabled, scope) {
  useEffect(() => {
    if (!enabled) return undefined;
    const { refresh } = useTicketUnread.getState();
    refresh();
    const timer = setInterval(refresh, 45000);
    window.addEventListener("focus", refresh);
    return () => {
      clearInterval(timer);
      window.removeEventListener("focus", refresh);
    };
  }, [enabled, scope]);
}

export const UnreadBadge = ({ count, className = "" }) =>
  count > 0 ? (
    <span className={`min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center ${className}`}>
      {count > 9 ? "9+" : count}
    </span>
  ) : null;
